module.exports = __webpack_public_path__ + "img/banner.f0f6e186.svg";